<template>
  <div :id="id" style="width:100%;height: 460px;"></div>
</template>
<script>
import { Column } from '@antv/g2plot';

export default {
  props: {
    list: Array
  },
  data() {
    return {
      dom: {},
      id: 'container_v' + Math.random(),
      ColumnPlot: {}
    };
  },
  watch: {
    list() {
      this.ColumnPlot.update(this.getOptions());
    }
  },
  created() {},
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.ColumnPlot = new Column(this.id, this.getOptions());
      this.ColumnPlot.render();
    },
    getOptions() {
      const data = this.list;
      return {
        data,
        padding: 'auto',
        xField: 'label',
        yField: 'value',
        label: {
          position: 'middle',
          style: {
            fill: '#FFFFFF',
            opacity: 0.6
          }
        }
      };
    }
  }
};
</script>
<style lang="less" scoped></style>
